:host {
  display: block;
  position: relative;
  width: 100%;
  aspect-ratio: var(--ratio);
}

:host([ratio='1x1']) {
  --ratio: 1 / 1;
}

:host([ratio='3x2']) {
  --ratio: 3 / 2;
}

:host([ratio='16x9']) {
  --ratio: 16 / 9;
}

:host([ratio='2x1']) {
  --ratio: 2 / 1;
}

:host([ratio='4x1']) {
  --ratio: 4 / 1;
}

:host([ratio='4x3']) {
  --ratio: 4 / 3;
}

:host([ratio='3x4']) {
  --ratio: 3 / 4;
}

:host([ratio='5x2']) {
  --ratio: 5 / 2;
}

:host([ratio='12x5']) {
  --ratio: 12 / 5;
}

:host([ratio='9x4']) {
  --ratio: 9 / 4;
}

:host([ratio='1x2']) {
  --ratio: 1 / 2;
}

:host([ratio='2x3']) {
  --ratio: 2 / 3;
}

:host([ratio='4x9']) {
  --ratio: 4 / 9;
}

::slotted(figure) {
  margin: 0;
}
